/**
 * XREF01 Sender/MedicalSpecialityCode.
 *
 * Stored on the clinic's Communicate connection
 * (`clinic_communicate_connections.medical_speciality_code`).
 * A missing or blank value stays null, so the referral form shows
 * "Ikke konfigureret" and blocks "Dan henvisning".
 */
export function readClinicMedicalSpecialityCode(
  code: string | null | undefined,
): string | null {
  if (typeof code !== 'string') return null;
  const trimmed = code.trim();
  return trimmed.length === 0 ? null : trimmed;
}
